import Api from '@/services/Api'
import qs  from "qs";
export default {
  signIn(credentials) {
    return Api().post('users/token', 
      qs.stringify(credentials),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    )
  },
  signUp(data) {
    return Api().post('auth/register', data)
  },
  updateUserDetails(data) {
    return Api().put('auth/updatedetails', data)
  },
  uploadUserAvatar(data) {
    return Api().put('auth/avatar', data)
  },
  updatePassword(data) {
    return Api().put('auth/updatepassword', data)
  },
  me(token) {
    return Api().get('users/me', {
      headers: { Authorization: `Bearer ${token}` }
    })
  }
}
